var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/search_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.76 13.5776L20.49 19.3076L19 20.7976L13.27 15.0676C12.2 15.8376 10.91 16.3076 9.5 16.3076C5.91 16.3076 3 13.3976 3 9.80756C3 6.21756 5.91 3.30756 9.5 3.30756C13.09 3.30756 16 6.21756 16 9.80756C16 11.2176 15.53 12.5076 14.76 13.5776ZM9.5 5.30756C7.01 5.30756 5 7.31756 5 9.80756C5 12.2976 7.01 14.3076 9.5 14.3076C11.99 14.3076 14 12.2976 14 9.80756C14 7.31756 11.99 5.30756 9.5 5.30756Z",
    fill: "#49454F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4823ff5f792bc8dc3b74f928dbe97b49.svg";
export { ForwardRef as ReactComponent };